import React from 'react';
import { CmsDestination } from '../../integrations/contentful/types';
import { spacing } from '../../styles/theme';
import H from '../elements/H';
import { t } from '../../utils/i18n';

interface MemoryTitleProps {
  title: string;
  startDate: string;
  endDate: string;
  destination: CmsDestination;
}

const MemoryTitle: React.FunctionComponent<MemoryTitleProps> = ({
  title,
  startDate,
  endDate,
  destination
}) => {
  return (
    <div>
      <H styling="h5">{t('Matka')}</H>
      <div className="h1">
        <H styling="h1">
          <strong>{title}</strong>
        </H>
      </div>
      <style jsx>{`
        .h1 {
          margin-bottom: ${spacing.one};
        }
      `}</style>
    </div>
  );
};

export default MemoryTitle;
